import { useRoute, useRouter } from 'vue-router'

import { runLoader } from '@collector/shared-ui'
import { queryClient } from '@desktop/queryClient'
import { Route } from '@desktop/router/routes'

import { DynamicRouteComponents } from '../types'

export const useDynamicRoutes = () => {
  const router = useRouter()
  const route = useRoute()

  const initRoutes = (components: DynamicRouteComponents) => {
    router.addRoute(Route.Relation, {
      name: Route.RelationStatistics,
      path: 'statistics',
      component: components.statistics,
      async beforeEnter(_, __, next) {
        const eventId = Number(route.params.eventId)
        const promises = [
          queryClient.refetchQueries({
            queryKey: ['event', 'participants', eventId],
            exact: true,
          }),
          queryClient.refetchQueries({
            queryKey: ['event', 'subParticipants', eventId],
            exact: true,
          }),
        ]
        await runLoader(Promise.all(promises))
        next()
      },
    })

    router.addRoute('relation', {
      name: Route.RelationMain,
      path: '',
      component: components.relation,
    })

    router.replace(route.fullPath)
  }

  return { initRoutes }
}
